import React from 'react';

/**
 * Responsive hero photograph.
 * - Provides <picture> with WebP + JPEG srcsets at multiple widths.
 * - Never overlaid with color/filter.
 * - Object-cover keeps composition centred.
 */
export function HeroPhoto({ className = '', rounded = 'rounded-2xl' }) {
  const alt = 'Horses at the Tollygunge Club Equestrian Centre';
  return (
    <picture>
      <source
        type="image/webp"
        srcSet="/images/hero-horses-480.webp 480w, /images/hero-horses-800.webp 800w, /images/hero-horses-1200.webp 1200w, /images/hero-horses-1600.webp 1600w"
        sizes="(max-width: 767px) 100vw, 50vw"
      />
      <source
        type="image/jpeg"
        srcSet="/images/hero-horses-480.jpg 480w, /images/hero-horses-800.jpg 800w, /images/hero-horses-1200.jpg 1200w, /images/hero-horses-1600.jpg 1600w"
        sizes="(max-width: 767px) 100vw, 50vw"
      />
      <img
        src="/images/hero-horses-1200.jpg"
        alt={alt}
        className={`w-full h-full object-cover ${rounded} ${className}`}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </picture>
  );
}
